import React, { useState } from "react";
import { logigloUrl } from "../../Config";
import "./instituteform.css";
import axios from "axios";

const InstituteForm = () => {
  const [institutionType, setInstitutionType] = useState("");
  const [message, setMessage] = useState("");
  const [institutionName, setInstitutionName] = useState("");
  const [others, setothers] = useState("");
  const [primaryContactName, setprimaryContactName] = useState("");
  const [primaryContactTitle, setprimaryContactTitle] = useState("");
  const [contactEmail, setcontactEmail] = useState("");
  const [contactPhone, setcontactPhone] = useState("");
  const [institutionWebsite, setinstitutionWebsite] = useState("");
  const [errors, setErrors] = useState({});
  const [error, setError] = useState("");
  const [file, setFile] = useState();
  const account = localStorage.getItem("token");

  const validateTextFields = (fieldName, value) => {
    const pattern = /^[A-Za-z\s]+$/;
    if (!pattern.test(value)) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [fieldName]: "Only letters are allowed",
      }));
    } else {
      setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: "" }));
    }
  };
  // Validation for email
  const validateEmail = (value) => {
    const pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!pattern.test(value)) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        email: "Please enter a valid email address",
      }));
    } else {
      setErrors((prevErrors) => ({ ...prevErrors, email: "" }));
    }
  };

  // Validation for phone number
  const validatePhoneNumber = (value) => {
    const pattern = /^[0-9]+$/;
    if (!pattern.test(value)) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        phone: "Please enter a valid 10-digit phone number",
      }));
    } else {
      setErrors((prevErrors) => ({ ...prevErrors, phone: "" }));
    }
  };
  const validateWebsite = (value) => {
    const websitePattern = /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,4}(\/.*)?$/;
    if (!websitePattern.test(value)) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        website: "Please enter a valid website URL (e.g., https://example.com)",
      }));
    } else {
      setErrors((prevErrors) => ({ ...prevErrors, website: "" }));
    }
  };
  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];

    if (selectedFile) {
      const fileType = selectedFile.type;
      // Validate file type (allow only images and PDFs)
      if (
        fileType === "image/png" ||
        fileType === "image/jpg" ||
        fileType === "image/jpeg" ||
        fileType === "image/svg" ||
        fileType === "application/pdf"
      ) {
        setFile(selectedFile);
        setError("");
      } else {
        setFile(null);
        setError("Please upload a valid file (image or PDF).");
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Perform validations
    validateTextFields("institutionName", institutionName);
    validateTextFields("primaryContactName", primaryContactName);
    validateTextFields("primaryContactTitle", primaryContactTitle);
    validateEmail(contactEmail);
    validatePhoneNumber(contactPhone);
    validateWebsite(institutionWebsite);

    // Check if there are any validation errors
    if (Object.values(errors).some((error) => error)) {
      setMessage("Please fix the errors before submitting.");
      return;
    }

    const form = new FormData();
    form.append("account_id", account ? JSON.parse(account).accountId : 164);
    form.append("institution_name", institutionName);
    form.append("type_of_institution", institutionType);
    form.append("primary_contact_name", primaryContactName);
    form.append("primary_contact_title_or_position", primaryContactTitle);
    form.append("contact_email_address", contactEmail);
    form.append("contact_phone_number", contactPhone);
    form.append("institution_website", institutionWebsite);
    form.append("specify", others);
    form.append("file", file);
    console.log("FIles", [...form]);
    try {
      const response = await axios({
        method: "POST",
        url: `${logigloUrl}/institutionEnquiry`,
        headers: {
          "Content-Type": "multipart/form-data",
        },
        data: form,
      });
      console.log(response);

      setMessage("Thank you for providing the details.");
      setInstitutionName("");
      setInstitutionType("");
      setothers("");
      setprimaryContactName("");
      setprimaryContactTitle("");
      setcontactEmail("");
      setcontactPhone("");
      setinstitutionWebsite(" ");
      setFile(null);

      document.getElementById("image-upload").value = "";

      setTimeout(() => {
        setMessage("");
      }, 20000);
    } catch (error) {
      console.error("There was a problem with the request:", error);
      
    }
  };
  return (
    <div id="institution-form">
      <h2 className="enquiry-heading">Institution Enquiry</h2>
      <form id="form" onSubmit={handleSubmit}>
        <div className="field-container">
          <label htmlFor="institution-name" className="institute-label ">
            Institution Name: <span> *</span>
          </label>
          <input
            type="text"
            id="institution-name"
            name="institutionName"
            value={institutionName}
            autoComplete="off"
            onChange={(e) => {
              setInstitutionName(e.target.value);
              validateTextFields("institutionName", e.target.value);
            }}
            onBlur={(e) =>
              validateTextFields("institutionName", e.target.value)
            }
            required
          />
          {errors.institutionName && (
            <p className="error-message">{errors.institutionName}</p>
          )}
        </div>

        <div className="field-container">
          <label htmlFor="type-of-institution" className="institute-label ">
            Type of Institution:<span> *</span>
          </label>
          <select
            id="type-of-institution"
            name="institutionType"
            value={institutionType}
            onChange={(e) => setInstitutionType(e.target.value)}
            required
          >
            <option value="" disabled>
              Select type
            </option>
            <option value="university">University</option>
            <option value="college">College</option>
            <option value="institute">Institute</option>
            <option value="other">Others</option>
          </select>
        </div>

        {institutionType === "other" && (
          <div className="field-container">
            <label
              htmlFor="type-of-institution-other"
              className="institute-label "
            >
              Specify: <span> *</span>
            </label>
            <input
              type="text"
              id="type-of-institution-other"
              name="typeOfInstituteOthers"
              value={others}
              onChange={(e) => setothers(e.target.value)}
              placeholder="Specify"
              required
            />
          </div>
        )}

        <div className="field-container">
          <label htmlFor="primary-contact-name" className="institute-label ">
            Primary Contact Name: <span> *</span>
          </label>
          <input
            type="text"
            id="primary-contact-name"
            name="primaryContactName"
            value={primaryContactName}
            onChange={(e) => {
              setprimaryContactName(e.target.value);
              validateTextFields("primaryContactName", e.target.value); // Using common validation function
            }}
            onBlur={(e) =>
              validateTextFields("primaryContactName", e.target.value)
            }
            autoComplete="off"
            required
          />
          {errors.primaryContactName && (
            <p className="error-message">{errors.primaryContactName}</p>
          )}
        </div>

        <div className="field-container">
          <label htmlFor="primary-contact-title" className="institute-label ">
            Primary Contact Title/Position: <span> *</span>
          </label>
          <input
            type="text"
            id="primary-contact-title"
            name="primaryContactTitle"
            value={primaryContactTitle}
            onChange={(e) => {
              setprimaryContactTitle(e.target.value);
              validateTextFields("primaryContactTitle", e.target.value);
            }}
            onBlur={(e) =>
              validateTextFields("primaryContactTitle", e.target.value)
            }
            autoComplete="off"
            required
          />
          {errors.primaryContactTitle && (
            <p className="error-message">{errors.primaryContactTitle}</p>
          )}
        </div>

        <div className="field-container">
          <label htmlFor="contact-email" className="institute-label ">
            Contact Email Address: <span> *</span>
          </label>
          <input
            type="email"
            id="contact-email"
            name="contactEmail"
            value={contactEmail}
            onChange={(e) => {
              setcontactEmail(e.target.value);
              validateEmail(e.target.value);
            }}
            onBlur={(e) => validateEmail(e.target.value)}
            autoComplete="new-email"
            required
          />
          {errors.email && <p className="error-message">{errors.email}</p>}
        </div>

        <div className="field-container">
          <label htmlFor="contact-phone" className="institute-label ">
            Contact Phone Number (Preferably WhatsApp Numbers): <span> *</span>
          </label>
          <input
            type="tel"
            id="contact-phone"
            name="contactPhone"
            value={contactPhone}
            onChange={(e) => {
              setcontactPhone(e.target.value);
              validatePhoneNumber(e.target.value);
            }}
            onBlur={(e) => validatePhoneNumber(e.target.value)}
            autoComplete="off"
            required
          />
          {errors.phone && <p className="error-message">{errors.phone}</p>}
        </div>

        <div className="field-container">
          <label htmlFor="institution-website" className="institute-label ">
            Institution Website: <span> *</span>
          </label>
          <input
            type="url"
            id="institution-website"
            name="institutionWebsite"
            value={institutionWebsite}
            onChange={(e) => {
              setinstitutionWebsite(e.target.value);
              validateWebsite(e.target.value);
            }}
            onBlur={(e) => validateWebsite(e.target.value)}
            autoComplete="off"
            required
          />
          {errors.website && <p className="error-message">{errors.website}</p>}
        </div>

        {/* Upload button commented */}
        {/* <div className="field-container">
          <label htmlFor="image-upload" className="institute-label">
            Upload Image :
          </label>
          <input
            type="file"
            id="image-upload"
            accept="image/*, application/pdf"
            onChange={handleFileChange}
          />

          {error && <p className="error-message">{error}</p>}
        </div> */}

        <div className="button-container">
          <input type="submit" value="Submit" style={{color : 'white'}} />
          <p className="mandatoryfield">(*) Mandatory Fields</p>
        </div>
        <p className="res-message">{message}</p>
      </form>
    </div>
  );
};

export default InstituteForm;
